document.addEventListener('DOMContentLoaded', function () {
    devtricker_process_recommendation_account_loadRecommendedAccounts();
});